module.exports = __webpack_public_path__ + "img/puzzel1-1.1c4e5b8d.png";